import { m } from '@/lib/paraglide/messages'

/** Hai mốc nhắc sự kiện mà loa máy trạm đọc lên (#M-154). */
const EVENT_TOMORROW = 'work_activity.event_tomorrow'
const EVENT_SOON = 'work_activity.event_soon'

/**
 * Giờ Việt Nam đọc thành tiếng: "14 giờ 30", "9 giờ". Viết "14:30" thì giọng
 * đọc tiếng Việt đọc thành "mười bốn hai chấm ba mươi".
 */
function spokenVnTime(iso: string): string | null {
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return null
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Ho_Chi_Minh',
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h23',
    }).formatToParts(d)
    const hour = Number(parts.find((p) => p.type === 'hour')?.value)
    const minute = Number(parts.find((p) => p.type === 'minute')?.value)
    return minute === 0
        ? m.station_work_speech_time_hour({ hour: String(hour) })
        : m.station_work_speech_time({
              hour: String(hour),
              minute: String(minute),
          })
}

/**
 * Câu loa máy trạm đọc cho một biến động bên bảng công việc. Chỉ HAI mốc nhắc
 * sự kiện mới được đọc — giao việc, nhắc họp, quá hạn vẫn chỉ nhảy màn như cũ.
 * Trả null khi không cần đọc hoặc thiếu dữ liệu để đọc thành câu trọn vẹn.
 */
export function workEventSpeech(event: {
    event?: string
    title?: string
    starts_at?: string
}): string | null {
    if (event.event !== EVENT_TOMORROW && event.event !== EVENT_SOON) {
        return null
    }
    if (!event.title || !event.starts_at) return null
    const time = spokenVnTime(event.starts_at)
    if (!time) return null
    return event.event === EVENT_TOMORROW
        ? m.station_work_event_speech_tomorrow({ title: event.title, time })
        : m.station_work_event_speech_soon({ title: event.title, time })
}
